import { Component, Input, OnInit, ChangeDetectorRef, OnDestroy, Output } from '@angular/core';
import { AlertsService, AsyncService, AuthService, HubService, INotificationResponse } from '../../../../../../services';
import { Subject, takeUntil } from 'rxjs';
import { tvbar } from '../../../../../../services/external/hub/context';
import { BarData } from '../../../../../../services/external/hub/datafeed';
import { hub } from '../../../../../../services/external/hub';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
 
@Component({
    selector: 'subscribe-notification',
    templateUrl: './subscribe-notification.component.html',
    styleUrls: ['./subscribe-notification.component.less'],
    animations: [
      trigger('flyInOut', [
        state('inactive', style({ opacity: 0 })),
        state('active', style({ opacity: 1 })),
        state('removed', style({ opacity: 0 })),
        transition(
          'inactive => active',
          animate('{{ easeTime }}ms {{ easing }}'),
        ),
        transition(
          'active => removed',
          animate('{{ easeTime }}ms {{ easing }}'),
        ),
      ]),
    ],
    preserveWhitespaces: false
})
export class SubscribeNotificationComponent extends Toast { 
  
    // constructor is only necessary when not using AoT
    constructor(
      protected override toastrService: ToastrService,
      public override toastPackage: ToastPackage,
    ) {
      super(toastrService, toastPackage);
    }
  
    action=(event: Event) =>{
      event.stopPropagation(); 
      this.toastPackage.triggerAction({actionButton:"subscribe", payload: this.toastPackage.config.payload } as INotificationResponse<any> );
      return false;
    }
  }